<script setup lang="ts"></script>
<template>
  <!-- #wrap -->
  <slot></slot>
  <!-- /#wrap -->
</template>
<style>
/*@import '@/assets/css/print.css';*/
@import '@/assets/css/print_new.css';
</style>
